import type { ChartData, Point } from 'chart.js'

import { EmptyChartData } from '@/components/charts/empty-chart-data.tsx'
import { LineChart } from '@/components/charts/line-chart.tsx'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card.tsx'

interface CompositionLineChartProps {
  title: string
  data?: ChartData<'line', (number | Point | null)[], unknown>
  isFetching: boolean
  showLegend?: boolean
  showCents?: boolean
  hideZeros?: boolean
}

export const CompositionLineChart = ({
  title,
  data,
  isFetching,
  showLegend,
  hideZeros,
  showCents,
}: CompositionLineChartProps) => {
  return (
    <Card className="flex flex-col xl:justify-between">
      <CardHeader className="pb-0">
        <CardTitle className="text-xl font-semibold leading-none">
          <div className="grid grid-flow-row justify-between sm:grid-flow-col">
            {title}
            <div className="flex gap-3 text-sm font-medium text-secondary-500 dark:text-white">
              {showLegend &&
                data &&
                data.datasets.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className="flex items-center gap-1"
                    >
                      <div
                        className="h-[8px] w-[8px] rounded"
                        style={{
                          backgroundColor: item.borderColor?.toString(),
                        }}
                      />
                      {item.label}
                    </div>
                  )
                })}
            </div>
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent className="flex h-full items-center justify-center sm:min-h-[350px]">
        {isFetching || !data ? (
          <EmptyChartData isFetching={isFetching} />
        ) : (
          <LineChart
            hideZeros={hideZeros}
            data={data}
            options={{
              maintainAspectRatio: false,
              scales: { x: { offset: false } },
            }}
            toggleOptions={{ isTooltipCurrency: true }}
            showCents={showCents}
          />
        )}
      </CardContent>
    </Card>
  )
}
